const DIALOG_FORM_TYPES = {
	SINGLE: 'single',
	MULTI: 'multi',
	STEPS: 'steps',
}

const DIALOG_FORM_WIDTH_SIZES = {
	SMALL: 'small',
	MEDIUM: 'medium',
	LARGE: 'large',
}

const DIALOG_FORM_WIDTH_SIZES_TO_PIXELS = {
	[DIALOG_FORM_WIDTH_SIZES.SMALL]: 428,
	[DIALOG_FORM_WIDTH_SIZES.MEDIUM]: 640,
	[DIALOG_FORM_WIDTH_SIZES.LARGE]: 832,
}

const DIALOG_FORM_MULTI_FORM_STEP_TYPES = {
	EDITING: 'editing',
	SUBMITTING: 'submitting',
}

const DIALOG_FORM_SAVE_ACTION_TYPES = {
	SIMPLE: 'simple',
	EDITING: 'editing',
	BINDING: 'binding',
	ONE_MORE_STEP: 'oneMoreStep',
	COPYING: 'copying',
	SHOWING: 'showing', // отображается кнопка Закрыть и нужно передать пропс showCancelButton="false" для скрытия кнопки Отмена
}

const DIALOG_FORM_SAVE_ACTION_EMITS = {
	'SAVE:CLOSE': 'save:close',
	'SAVE:CONTINUE': 'save:continue',
	'SAVE:CREATE_NEW': 'save:createNew',
	'SAVE:COPY': 'save:copy',
	'CLOSE:MULTI_FORM': 'close:multiForm',
	'CLOSE': 'close',
	'STEP:CONTINUE': 'step:continue',
	'STEP:CLOSE': 'step:close',
	'STEP:BACK': 'step:back',
}

Object.freeze(DIALOG_FORM_TYPES)
Object.freeze(DIALOG_FORM_WIDTH_SIZES)
Object.freeze(DIALOG_FORM_WIDTH_SIZES_TO_PIXELS)
Object.freeze(DIALOG_FORM_MULTI_FORM_STEP_TYPES)
Object.freeze(DIALOG_FORM_SAVE_ACTION_TYPES)
Object.freeze(DIALOG_FORM_SAVE_ACTION_EMITS)

const DIALOG_FORM_CUSTOM_PROPS_PROP = {
	type: Object,
	default: () => ({}),
}

const DIALOG_FORM_IS_ACTIVE_PROP = {
	type: Boolean,
	default: false,
}

const DIALOG_FORM_HIDDEN_TABS_PROP = {
	type: Array,
	default: () => ([]),
}

const DEFAULT_DIALOG_FORM_PROPS = {
	customProps: DIALOG_FORM_CUSTOM_PROPS_PROP,

	isActive: DIALOG_FORM_IS_ACTIVE_PROP,

	hiddenTabs: DIALOG_FORM_HIDDEN_TABS_PROP
}

/**
 * Типы emits которые вызываются в формах сущностей
 * При сохранении вызываются два емита: SAVED и SAVED{VARIANT} (ex: SAVED_CLOSE), и соответственно можно подписаться как на общий так и на конкретные вариант сохранения
 */
const ENTITY_DIALOG_FORM_EMIT_TYPES = {
	CANCEL: 'cancel',
	CLOSE: 'close',
	SAVED: 'saved',
	SAVED_CLOSE: 'saved:close',
	SAVED_CONTINUE: 'saved:continue',
	SAVED_CREATE_NEW: 'saved:createNew',
}

/**
 * возможный нейминг emits:
 * saved:close - после создания/редактировании сущности
 * updated:[entity] - когда в форме создавали или редактировали дочерние сущности
 */
const DEFAULT_DIALOG_FORM_EMITS = {
	[ENTITY_DIALOG_FORM_EMIT_TYPES.CANCEL]: null,
	[ENTITY_DIALOG_FORM_EMIT_TYPES.CLOSE]: null,
	[ENTITY_DIALOG_FORM_EMIT_TYPES.SAVED]: null,
}

Object.freeze(DIALOG_FORM_CUSTOM_PROPS_PROP)
Object.freeze(DIALOG_FORM_IS_ACTIVE_PROP)
Object.freeze(DIALOG_FORM_HIDDEN_TABS_PROP)
Object.freeze(DEFAULT_DIALOG_FORM_PROPS)
Object.freeze(ENTITY_DIALOG_FORM_EMIT_TYPES)
Object.freeze(DEFAULT_DIALOG_FORM_EMITS)


const ABSTRACT_DIALOG_FORM_PROPS = {

	formType: {
		type: String,
		default: DIALOG_FORM_TYPES.SINGLE,
		validator: (value) => {
			return [
				DIALOG_FORM_TYPES.SINGLE,
				DIALOG_FORM_TYPES.MULTI,
				/* Для пошаговой формы игнорируется параметр saveActionType,
					так же нужно указать stepFormIsLastStep для смены кнопки "продолжить" на "закрыть"
					игнорируется isSubmitting и вместо него на кнопке "продолжить" отображается прелоадер если передан stepFormStepIsProcessing
				*/
				DIALOG_FORM_TYPES.STEPS,
			].includes(value)
		},
	},

	multiFormStep: {
		type: String,
		default: DIALOG_FORM_MULTI_FORM_STEP_TYPES.EDITING,
		validator: (value) => {
			return [DIALOG_FORM_MULTI_FORM_STEP_TYPES.EDITING, DIALOG_FORM_MULTI_FORM_STEP_TYPES.SUBMITTING].includes(value)
		},
	},

	formTitle: {
		type: String,
		default: '',
	},

	formSubtitle: {
		type: String,
		default: null,
	},

	showHeaderLine: {
		type: Boolean,
		default: true,
	},

	dialogProps: {
		type: Object,
		default: () => ({}),
	},

	isActiveDialog: {
		type: Boolean,
		default: false,
	},

	isLoading: {
		type: Boolean,
		default: false,
	},

	isLoaded: {
		type: Boolean,
		default: true,
	},

	isLoadedWithError: {
		type: Boolean,
		default: false,
	},

	dialogFormErrorMessage: {
		type: String,
		default: null,
	},

	/* игнорируется если указать formType: DIALOG_FORM_TYPES.STEPS */
	isSubmitting: {
		type: Boolean,
		default: false,
	},

	/**
	 * @description Параметр определяет какие кнопки сохранения использовать
	 * игнорируется если указать formType: DIALOG_FORM_TYPES.STEPS
	 */
	saveActionType: {
		type: String,
		default: DIALOG_FORM_SAVE_ACTION_TYPES.SIMPLE,
		validator: (value) => {
			return [
				DIALOG_FORM_SAVE_ACTION_TYPES.SIMPLE,
				DIALOG_FORM_SAVE_ACTION_TYPES.EDITING,
				DIALOG_FORM_SAVE_ACTION_TYPES.BINDING,
				DIALOG_FORM_SAVE_ACTION_TYPES.ONE_MORE_STEP,
				DIALOG_FORM_SAVE_ACTION_TYPES.COPYING,
				DIALOG_FORM_SAVE_ACTION_TYPES.SHOWING,
			].includes(value)
		},
	},

	showCancelButton: {
		type: Boolean,
		default: true,
	},

	isDisabledActions: {
		type: Boolean,
		default: false,
	},

	preFillingOutFormValidationErrors: {
		type: Array,
		default: () => ([]),
	},

	stepFormIsLastStep: {
		type: Boolean,
		default: false,
	},

	stepFormIsShowPrevStepAction: {
		type: Boolean,
		default: false,
	},

	stepFormStepIsProcessing: {
		type: Boolean,
		default: false,
	},

	contentClass: {
		type: String,
		default: '',
	},

	showDevTools: {
		type: Boolean,
		default: false,
	},

}

const ABSTRACT_DIALOG_FORM_EMITS = {
	'cancel': null,
	'save:close': null,
	'save:continue': null,
	'save:createNew': null,
	'save:copy': null,
	'close': null,
	'close:multiForm': null,
	'step:continue': null,
	'step:close': null,
	'step:back': null,
}

Object.freeze(ABSTRACT_DIALOG_FORM_PROPS)
Object.freeze(ABSTRACT_DIALOG_FORM_EMITS)

/**
 * @description типы событий которые передаются от компонента FormControl к useFormManager через емит eventTriggered
 */
const FORM_CONTROL_EVENT_TYPES = {
	UPDATE_VALUE: 'update:value',
	UPDATE_GEOMETRY_AREA: 'update:geometry-area',
	BLUR: 'blur',
}
Object.freeze(FORM_CONTROL_EVENT_TYPES)

const SPECIFIC_CONTROL_TYPES = {
	SLIDER: 'slider',
	TOGGLE: 'toggle'
}
Object.freeze(SPECIFIC_CONTROL_TYPES)

const FORM_SELECT_PROPS = {

	modelValue: {
		type: [Number, Array],
		// required: true,
	},

	error: {
		type: Boolean,
		default: false,
	},

	errorMessages: {
		type: Array,
		default: () => [],
	},

	hideDetails: {
		type: [Boolean, String],
		default: 'auto',
	},

	isSearch: {
		type: Boolean,
		default: true,
	},

	showAddButton: {
		type: Boolean,
		default: true,
	},

	label: {
		type: String,
		default: null,
	},

	multiselect: {
		type: Boolean,
		default: false,
	},

	clearable: {
		type: Boolean,
		default: false,
	},

	/**
	 * @description Функция которая вызывается после загрузки элементов в select
	 * @param {Array} items
	 * @returns {Promise<Array>} items
	 */
	postLoadingItemsProcessCallback: {
		type: Function,
		default: null,
	},

	/**
	 * @description Метод при помощи которого можно сформировать из полного списка сокращенный
	 * @param {Array} items
	 * @returns {Promise<Array>} shortList
	 */
	getShortItemsListCallback: {
		type: Function,
		default: null,
	},

}
Object.freeze(FORM_SELECT_PROPS)

const FORM_SELECT_EMIT_TYPES = {
	UPDATE_MODEL_VALUE: 'update:modelValue',
	BLUR: 'blur',
}
Object.freeze(FORM_SELECT_EMIT_TYPES)

const FORM_SELECT_EMITS = {
	[FORM_SELECT_EMIT_TYPES.UPDATE_MODEL_VALUE]: null,
	[FORM_SELECT_EMIT_TYPES.BLUR]: null,
}
Object.freeze(FORM_SELECT_EMITS)

export {
	DIALOG_FORM_TYPES,
	DIALOG_FORM_WIDTH_SIZES,
	DIALOG_FORM_WIDTH_SIZES_TO_PIXELS,
	DIALOG_FORM_MULTI_FORM_STEP_TYPES,
	DIALOG_FORM_SAVE_ACTION_TYPES,
	DIALOG_FORM_SAVE_ACTION_EMITS,
	DIALOG_FORM_CUSTOM_PROPS_PROP,
	DIALOG_FORM_IS_ACTIVE_PROP,
	DIALOG_FORM_HIDDEN_TABS_PROP,
	DEFAULT_DIALOG_FORM_PROPS,
	ENTITY_DIALOG_FORM_EMIT_TYPES,
	DEFAULT_DIALOG_FORM_EMITS,
	ABSTRACT_DIALOG_FORM_PROPS,
	ABSTRACT_DIALOG_FORM_EMITS,
	FORM_CONTROL_EVENT_TYPES,
	SPECIFIC_CONTROL_TYPES,
	FORM_SELECT_PROPS,
	FORM_SELECT_EMIT_TYPES,
	FORM_SELECT_EMITS,
}
